/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedStaticPageAdmin } from './PaginatedStaticPageAdmin'
import {
  PaginatedStaticPageAdminFromJSON,
  PaginatedStaticPageAdminFromJSONTyped,
  PaginatedStaticPageAdminToJSON,
} from './PaginatedStaticPageAdmin'

/**
 *
 * @export
 * @interface EnvelopedStaticPageListStaticPageAdmin
 */
export interface EnvelopedStaticPageListStaticPageAdmin {
  /**
   *
   * @type {PaginatedStaticPageAdmin}
   * @memberof EnvelopedStaticPageListStaticPageAdmin
   */
  body: PaginatedStaticPageAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedStaticPageListStaticPageAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedStaticPageListStaticPageAdmin interface.
 */
export function instanceOfEnvelopedStaticPageListStaticPageAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedStaticPageListStaticPageAdminFromJSON(
  json: any,
): EnvelopedStaticPageListStaticPageAdmin {
  return EnvelopedStaticPageListStaticPageAdminFromJSONTyped(json, false)
}

export function EnvelopedStaticPageListStaticPageAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedStaticPageListStaticPageAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedStaticPageAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedStaticPageListStaticPageAdminToJSON(
  value?: EnvelopedStaticPageListStaticPageAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedStaticPageAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
